import React from 'react';
import classNames from './style.module.scss';

interface Props {
    count: number;
    label?: string;
}

const ItemCount: React.FC<Props> = ({ count, label = 'total items' }) => {
    return ( 
        <div className="d-flex justify-content-end">
            <div className={classNames.itemCount}>
                <i className="bi bi-bag-check-fill"></i>
                <span>{count} {label}</span>
            </div>
        </div>
     );
}
 
export default ItemCount;